module.exports = { "default": require("core-js/library/fn/get-iterator"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// D:/xampp_bk/htdocs/xampp/organicshop/~/babel-runtime/core-js/get-iterator.js
// module id = ../../../../babel-runtime/core-js/get-iterator.js
// module chunks = 3